import React from "react";

import { Body1, SubBody } from "Cobalt/BodyText";
import Button from "Cobalt/Button";
import { ModalBody, ModalFooter } from "Cobalt/Modal";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("AddAncillaryPlanModal");

export const DonePage = ({ onHide }) => (
  <>
    <ModalBody>
      <Body1 mb={4}>
        <Icon icon="check-circle" size="xl" className={bem("checkIcon")} mr={3} ml={0} />
        Complete! We have everything we need.
      </Body1>
      <SubBody pb={4}>We will email your exact quote when it becomes available or you can check back here in 24-48 hours</SubBody>
    </ModalBody>
    <ModalFooter>
      <Button color="primary" className="float-right" onClick={onHide}>
        Finish
      </Button>
    </ModalFooter>
  </>
);
